import React,{useState} from 'react';
import './SearchNav.scss';
import { CustomSearchField } from '../../CommonComponent';
import partsservice from '../../../services/partsservice';
import { useSelector } from 'react-redux';
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";

const SearchNav = (props :any) => {
    const { guestUserUrlLink } = props;
    const [searchQuery, setSearchQuery] = useState('');
    const [data, setData] = useState<any[]>([]);
    const {
        globalData
    }: any = useSelector(
        state => ({
            globalData: globalDataSelector.globaldata(state),
        })
    );

    const onSearchTextChange = (e :any) => {
        setSearchQuery(e.target.value);
        if (e.target.value?.length >= 3) {
           partsservice.getProductSuggestions(e.target.value, globalData?.DistributorCode).then((response: any) => {
               setData(response?.globalSearchListSuggests??[]);
            }).catch((e: any) => {
                setData([]);
            });
        }
    }

    return (
        <div className='SearchNav'>
            <div className='searchNav_Container'>
                <div className='search_Wrapper'>
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={onSearchTextChange}
                        placeholder='Part Name/Part Description/Category Name/Part Number'
                        className={'Searchinput'}
                    />

                    <CustomSearchField data={data} searchQuery={searchQuery} guestUserUrlLink={guestUserUrlLink} />
                </div>
            </div>
        </div>
    );
};

export default SearchNav;